import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfirmLocationModalComponent } from '../confirm-location-modal/confirm-location-modal.component';
import { LocationSelection, validLocation } from 'src/app/services/location-lookup.service';

@Component({
  selector: 'app-set-location-modal',
  templateUrl: './set-location-modal.component.html',
  styleUrls: ['./set-location-modal.component.scss']
})
export class SetLocationModalComponent {
  @ViewChild('setLocationModal') setLocationTemplate!: TemplateRef<any>;
  @ViewChild('confirmLocationModal') confirmLocationComponent!: ConfirmLocationModalComponent;
  @Output() locationEmit = new EventEmitter<LocationSelection>();

  confirmSelection(location: LocationSelection | null, modal: any): void {
    if (!validLocation(location)) return;
    modal.close();
    this.confirmLocationComponent.open(location);
  }
}
